import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "hidden", "settlementField", "settlementInput"]

  connect() {
    this.updateVisibility()
  }

  toggle() {
    this.updateVisibility()
  }

  updateVisibility() {
    const isChecked = this.checkboxTarget.checked
    this.hiddenTarget.disabled = isChecked
    this.settlementFieldTarget.style.display = isChecked ? "" : "none"

    if (isChecked) {
      this.settlementInputTarget.setAttribute("required", "true")
    } else {
      this.settlementInputTarget.removeAttribute("required")
      this.settlementInputTarget.value = ""
    }
  }
}
